import "../../../arac-takip/src/components/Navbar.css";
import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";

export default function Navbar({ perms = {} }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handler = (e) => {
      if (!e.target.closest(".navbar")) setMenuOpen(false);
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img src="/logo.png" alt="logo" className="navbar-logo" />
        <span className="navbar-title">Kontrol Formları</span>
      </div>

      {user && (
        <>
          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            <span></span><span></span><span></span>
          </div>

          <div className={`navbar-links ${menuOpen ? "show" : ""}`}>
            {perms.canFill && (
              <NavLink className="navbar-link" to="/kontrol-formlari/form-doldur">
                Form Doldur
              </NavLink>
            )}
            {perms.canCreate && (
              <NavLink className="navbar-link" to="/kontrol-formlari/formlar">
                Form Oluştur
              </NavLink>
            )}
            {perms.canViewIssues && (
              <NavLink className="navbar-link" to="/kontrol-formlari/eksiklikler">
                Eksiklikler
              </NavLink>
            )}
            {perms.canMail && (
              <NavLink className="navbar-link" to="/kontrol-formlari/mail-ayarlari">
                Mail Ayarları
              </NavLink>
            )}
            <NavLink className="navbar-link" to="/secilen-proje">Proje Seç</NavLink>
            <button type="button" className="logout-button" onClick={handleLogout}>Çıkış</button>
          </div>
        </>
      )}
    </nav>
  );
}
